'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { OptimizedImage } from '@/components/images';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Cancel01Icon } from '@/components/ui/icon/glyphs';
import { Panel, PanelContent } from '@/components/ui/panel';
import { onEvent } from '@/events';
import { useHydrated } from '@/hooks/ui/use-hydrated';
import { appUpsellProperties } from '@/lib/app-upsells/analytics';
import { usePortfolioAppUpsellDismissalStore } from '@/stores/portfolio-app-upsell-dismissal';
import { AppDownloadAction } from './app-download-action';
import { useUpsellImpression } from './use-upsell-impression';
export function PortfolioAppUpsellCard() {
  const $ = _c(28);
  const t = useTranslations("app_upsells");
  const dismissed = usePortfolioAppUpsellDismissalStore(_temp);
  const dismiss = usePortfolioAppUpsellDismissalStore(_temp2);
  const hydrated = useHydrated();
  const ref = useUpsellImpression("portfolio");
  if (hydrated && dismissed) {
    return null;
  }
  let t0;
  if ($[0] !== dismiss) {
    t0 = function handleDismiss() {
      onEvent("app_upsell_dismissed", appUpsellProperties("portfolio", "portfolio"));
      dismiss();
    };
    $[0] = dismiss;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleDismiss = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pointer-events-none absolute top-1/2 left-0 -translate-x-6 -translate-y-1/2" aria-hidden="true"><OptimizedImage variant="thumbnail" src="/icons/morfi-logomark.svg" alt="" size="size-20" preview={false} nsfw={false} loadReveal="none" /></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("portfolio_title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <h2 className="text-body font-medium">{t2}</h2>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("portfolio_description");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <p className="text-caption text-foreground-secondary">{t4}</p>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="min-w-0 flex-1 pr-6 sm:pr-0">{t3}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="sm:pr-7"><AppDownloadAction surface="portfolio" /></div>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6) {
    t8 = <PanelContent className="relative flex flex-1 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">{t1}<div className="relative flex min-w-0 flex-1 flex-col gap-3 pl-[calc(theme(spacing.20)+0.75rem-1rem-1.5rem)] sm:flex-row sm:items-center sm:justify-between">{t6}{t7}</div></PanelContent>;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("portfolio_dismiss");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== handleDismiss || $[20] !== t9) {
    t10 = <AnimatedButton variant="tertiary" size="xs" prefix={Cancel01Icon} onClick={handleDismiss} aria-label={t9} disableHoverScale={true} className="absolute top-2 right-2 opacity-60 hover:opacity-100" />;
    $[19] = handleDismiss;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <Panel className="relative h-full overflow-hidden">{t8}{t10}</Panel>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== ref || $[26] !== t11) {
    t12 = <div ref={ref} className="min-w-0 flex-1" data-testid="portfolio-app-upsell-card">{t11}</div>;
    $[25] = ref;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
}
function _temp2(state_0) {
  return state_0.dismiss;
}
function _temp(state) {
  return state.dismissed;
}